/**
 * Bundled under /docs/ai/ — keep in sync with promang-docs/public/docs/ai/skills/
 */
export const AI_SKILLS_INDEX_PATH = "/docs/ai/skills.md";

export const AI_SKILLS_CATALOG = [
  {
    id: "overview",
    path: AI_SKILLS_INDEX_PATH,
    titleKey: "ai_skills.nav.overview",
    skill: false,
  },
  {
    id: "prompting-basics",
    path: "/docs/ai/skills/prompting-basics/SKILL.md",
    titleKey: "ai_skills.nav.prompting_basics",
    skill: true,
  },
  {
    id: "promang-ai-generator",
    path: "/docs/ai/skills/promang-ai-generator/SKILL.md",
    titleKey: "ai_skills.nav.promang_ai_generator",
    skill: true,
  },
  {
    id: "microsoft-mail-ai",
    path: "/docs/ai/skills/microsoft-mail-ai/SKILL.md",
    titleKey: "ai_skills.nav.microsoft_mail_ai",
    skill: true,
  },
  {
    id: "guide-flow-ai",
    path: "/docs/ai/skills/guide-flow-ai/SKILL.md",
    titleKey: "ai_skills.nav.guide_flow_ai",
    skill: true,
  },
  {
    id: "cursor-for-promang",
    path: "/docs/ai/skills/cursor-for-promang/SKILL.md",
    titleKey: "ai_skills.nav.cursor_for_promang",
    skill: true,
  },
  {
    id: "agent-integrations",
    path: "/docs/integrations/AI_AGENT_DATA_TOOLS.md",
    titleKey: "ai_skills.nav.agent_integrations",
    skill: false,
  },
  {
    id: "agent-product",
    path: "/docs/ai/skills/agent-product/SKILL.md",
    titleKey: "ai_skills.nav.agent_product",
    skill: true,
  },
  {
    id: "agent-customer",
    path: "/docs/ai/skills/agent-customer/SKILL.md",
    titleKey: "ai_skills.nav.agent_customer",
    skill: true,
  },
  {
    id: "agent-project",
    path: "/docs/ai/skills/agent-project/SKILL.md",
    titleKey: "ai_skills.nav.agent_project",
    skill: true,
  },
  {
    id: "agent-case",
    path: "/docs/ai/skills/agent-case/SKILL.md",
    titleKey: "ai_skills.nav.agent_case",
    skill: true,
  },
  {
    id: "agent-tasks",
    path: "/docs/ai/skills/agent-tasks/SKILL.md",
    titleKey: "ai_skills.nav.agent_tasks",
    skill: true,
  },
  {
    id: "agent-hse-document",
    path: "/docs/ai/skills/agent-hse-document/SKILL.md",
    titleKey: "ai_skills.nav.agent_hse_document",
    skill: true,
  },
  {
    id: "agent-meeting-minutes",
    path: "/docs/ai/skills/agent-meeting-minutes/SKILL.md",
    titleKey: "ai_skills.nav.agent_meeting_minutes",
    skill: true,
  },
];
